import { Link } from "react-router-dom"
import React, { useEffect, useState } from "react";
// import lob from './Asset/gif.gif';
// import logo from "./Asset/Oku's Office.png";
// import log from "./Asset/Oku's Office.png";
import { FaLinkedin } from "react-icons/fa6";
import Socials from "./Socials";
// import lob from "./Asset/nfc.png";
// import lob from '../Assets/1.png';




const Footer2 = () => {

    const Links = [
        {
            link: "Home"
        },
        {
            link: "Gallery"
        },
        {
            link: "Blog"
        },
        {
            link: "More"
        }
    ]
    const [active, setActive] = useState("");
    const [toggle, setToggle] = useState(false);
    const [scrolled, setScrolled] = useState(false);
  
    useEffect(() => {
      const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 100) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
  
      window.addEventListener("scroll", handleScroll);
  
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <footer 
        aria-label="Site Footer" 
        className="w-[100%] dark:bg-gradient-to-r from-black to-stone-700 z-30 lg:px-20 bg-white " 
        // class="bg-secondary"
        // style={{	
        //     // background: linear-gradient(href bottom right, #c04de2, #340c7f)  
        //     backgroundImage: 'linear-gradient(104deg, #fff 0%, #ccc 100%)'     }}
            >
        {/* <footer aria-label="Site Footer" class="bg-[#006eff]"> */}
       
            <div class="mx-auto max-w-screen-xl px-4 pt-16 pb-6 sm:px-6  z-50 lg:px-8 lg:pt-24">
                <div class="grid grid-cols-1 gap-4 lg:grid-cols-3">
                    

                    <div
                        class="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4 lg:col-span-3"
                    >
                        <div>
                        <div class="flex justify-center sm:justify-start">
                            <h1 className="dark:text-white text-8xl font-bold">O</h1>
                            {/* <img src={lob} className='w-60 h-auto object-contain' /> */}
                              {/* Image visible in dark mode */}
  {/* <img src={"https://i.pinimg.com/originals/d9/b3/64/d9b36499c49020888be8e8add816ddc5.gif"} className="hidden dark:inline w-40" alt="Dark Mode Logo" /> */}

{/* Image visible in light mode */}
{/* <img src={"https://i.pinimg.com/originals/d9/b3/64/d9b36499c49020888be8e8add816ddc5.gif"} className="inline dark:hidden w-40" alt="Light Mode Logo" /> */}
                            {/* <img src={lob} className='w-60 h-auto object-contain' /> */}
                            {/* <img src='https://earthsky.org/upl/2023/07/Rotating_earth_wikimedia-commons.gif' className='w-32 h-auto object-contain' /> */}
                            {/* <img src="https://static.wixstatic.com/media/84770f_b9252f3e5f93c72828fc613beee1af78.gif" className='w-32 h-auto object-contain' /> */}
                        </div>

                        <p
                            style={{ fontSize: 16 }}
                            class="mx-auto mt-6 max-w-md text-center leading-relaxed text-gray-800 dark:text-white sm:mx-0 sm:max-w-xs sm:text-left"
                        >
Oku's Office explores the endless possibilities.
                        </p>

      
                    </div>
                        {/* <div class="text-center sm:text-left">
                            <p class="text-lg font-medium text-gray-800">Our Media</p>

                            <nav aria-label="Footer About Nav" class="mt-8">
                                <ul class="space-y-4 text-sm">
                                    <li>
                                        <Link
                                            style={{ fontSize: 15 }}
                                            class="text-gray-800 transition hover:text-gray-700/75"
                                            href="/STV"
                                        >
                                            Starcross TV
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            style={{ fontSize: 15 }}
                                            class="text-gray-800 transition hover:text-gray-700/75"
                                            href="/EGC"
                                        >
                                            Everlasting Gospel
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            style={{ fontSize: 15 }}
                                            class="text-gray-800 transition hover:text-gray-700/75"
                                            href="/NKT"
                                        >
                                            New Kingdom Trumpet
                                        </Link>
                                    </li>
                                

                                </ul>
                            </nav>
                        </div> */}

                        <div class="text-center text-gray-800 dark:text-white sm:text-left">
                            <p class="text-lg ">Quick Link</p>

                            <nav aria-label="Footer Services Nav" class="mt-8">
                                <ul class="space-y-4 text-sm">
                                <li>
                                        <a
                                                  href='/'
                                                  onClick={() => {
                                                    setActive("");
                                                    window.scrollTo(0, 0);
                                                  }}
                                            // style={{ fontSize: 15 }}
                                            class=" transition hover:text-gray-700/75"
                                        >
                                            Home
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            // style={{ fontSize: 15 }}
                                            class=" transition hover:text-gray-700/75"
                                            href="#about"
                                            onClick={() => {
                                                setActive("");
                                                window.scrollTo(0, 0);
                                              }}
                                        >
                                            About
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            // style={{ fontSize: 15 }}
                                            class="group flex justify-center gap-1.5 sm:justify-start"
                                            // href="/STV"
                                            onClick={() =>alert('Coming Soon')}
                                        >
                                            <span
                                                class=" transition group-hover:text-gray-700/75"
                                            >
                                                Watch Oku's Office Live
                                            </span>

                                            <span class="relative -mr-2 flex h-2 w-2">
                                                <span
                                                    class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75"
                                                ></span>
                                                <span
                                                    class="relative inline-flex h-2 w-2 rounded-full bg-red-600"
                                                ></span>
                                            </span>
                                        </a>
                                    </li>
                                    {/* <li>
                                        <Link
                                            style={{ fontSize: 15 }}
                                            class="text-gray-800 transition hover:text-gray-700/75"
                                            href="https://www.arielfoundation.org/publications"
                                        >
                                            Books
                                        </Link>
                                    </li> */}

                                </ul>
                            </nav>
                        </div>

                        {/* <div class="text-center sm:text-left">
                            <p class="text-lg font-medium text-gray-800">For you</p>

                            <nav aria-label="Footer Helpful Nav" class="mt-8">
                                <ul class="space-y-4 text-sm">

                                    <li>
                                        <Link
                                            style={{ fontSize: 15 }}
                                            class="group flex justify-center gap-1.5 sm:justify-start"
                                            // href="/STV"
                                            onClick={() =>alert('Coming Soon')}
                                        >
                                            <span
                                                class="text-gray-800 transition group-hover:text-gray-700/75"
                                            >
                                                Watch Oku's Office Live
                                            </span>

                                            <span class="relative -mr-2 flex h-2 w-2">
                                                <span
                                                    class="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75"
                                                ></span>
                                                <span
                                                    class="relative inline-flex h-2 w-2 rounded-full bg-red-600"
                                                ></span>
                                            </span>
                                        </Link>
                                    </li>
                                </ul>
                            </nav>
                        </div> */}


                        {/* <div class="text-center sm:text-left">
                            <p class="text-lg font-medium text-gray-800">Hearty</p>

                            <nav aria-label="Footer Helpful Nav" class="mt-8">
                                <ul class="space-y-4 text-sm">

                                <li>
                                        <Link
                                            style={{ fontSize: 15 }}
                                            class="text-gray-800 transition hover:text-gray-700/75"
                                            href="https://globalleaderstoday.online/a-symbol-of-humanitarian-empowerment/"
                                        >
                                            Human Right
                                        </Link>
                                    </li>

                                <li>
                                        <Link
                                            style={{ fontSize: 15 }}
                                            class="text-gray-800 transition hover:text-gray-700/75"
                                            href="https://www.arielfoundation.org"
                                        >
                                            Ariel Foundation
                                        </Link>
                                    </li>

                               
                                    <li>
                                        <Link
                                            style={{ fontSize: 15 }}
                                            class="text-gray-800 transition hover:text-gray-700/75"
                                            href="https://www.arielfoundation.org/publications"
                                        >
                                            Pubilcations
                                        </Link>
                                    </li>
                                 
                                    
                                </ul>
                            </nav>
                        </div> */}

                        <div class="text-center text-gray-800 dark:text-white sm:text-left">
                            <p class="m-2 ">Subscribe to get emails from Oku's Office</p>

                            <input className="p-2 my-5 px-4 bg-[#eee] rounded-2xl" placeholder="Email..."  type="email"/>
                            <button onClick={() => alert('Successful')} className="p-3 px-5 m-2 text-xs lg:ml-text-gray-800 bg-white text-yellow-600 font-bold rounded-2xl">
                                Subscribe
                            </button>
                        </div>


                        <div class="lg:text-start text-center text-gray-800 dark:text-white">
                        <p class="text-lg m-2 ">Contact Address</p>

                            <p class="m-2 ">
                            Oku's Office 151 Wooster Street New York, NY 10012 UNITED STATES OF AMERICA
</p>

                            
                        </div>


                    </div>
                </div>


              


                <div class="container pt-16 flex justify-center  items-center">
                {/* <div class="grid lg:grid-cols-6 md:grid-cols-3 gap-4">
                    <a href="/Gallery" class="lg:mb-0 mb-6 hover:animate-bounce">
                        <img
                            src={img1}
                            class="w-full rounded-md shadow-lg"
                        />
                    </a>
                                        <a href="/Gallery" class="lg:mb-0 mb-6 hover:animate-bounce">

                        <img
                            src={img2}
                            class="w-full rounded-md shadow-lg"
                        />
                    </a>
                                        <a href="/Gallery" class="lg:mb-0 mb-6 hover:animate-bounce">

                        <img
                            src={img3}
                            class="w-full rounded-md shadow-lg"
                        />
                    </a>
                                        <a href="/Gallery" class="lg:mb-0 mb-6 hover:animate-bounce">

                        <img
                            src={img4}
                            class="w-full rounded-md shadow-lg"
                        />
                    </a>
                                        <a href="/Gallery" class="lg:mb-0 mb-6 hover:animate-bounce">

                        <img
                            src={img5}
                            class="w-full rounded-md shadow-lg"
                        />
                    </a>
                                        <a href="/Gallery" class="lg:mb-0 mb-6 hover:animate-bounce">

                        <img
                            src={img6}
                            class="w-full rounded-md shadow-lg"
                        />
                    </a>
                </div> */}
                {/* <Slider /> */}
            </div>

<Socials title={"me"} />
           



                <div class="mt-5 border-t border-gray-500 text-gray-800 dark:text-white pt-6">
                    <div class="text-center sm:flex sm:justify-between sm:text-left">
                        <p class="text-sm ">
                            <span class="block sm:inline">All rights reserved </span>

                            {/* <a
                                class="inline-block text-gray-800 underline transition hover:text-teal-600/75"
                                href="/"
                            > */}
                            {/* </a> */}

                            {/* <span>&middot;</span> */}

                            {/* <a
                                class="inline-block text-gray-300 underline transition hover:text-teal-600/75"
                                href="/"
                            > */}
                            {/* Terms & Conditions  
                                 Privacy Policy  */}
                            {/* </a> */}
                        </p>

                        <p class="mt-4 text-sm sm:order-first sm:mt-0">
                            &copy; {(new Date().getFullYear())} Oku's Office
                        </p>
                    </div>
                </div>
            </div>
        </footer>

    )
}

export default Footer2;